import React, {Component} from 'react';
import PropTypes from 'prop-types';

class UploadIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="14px"
          height="17px"
          viewBox="0 0 14 17"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-849.000000, -5885.000000)"
            >
              <g id="General-Icons" transform="translate(56.000000, 400.000000)">
                <g id="row" transform="translate(0.000000, 5444.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="general-/-upload-/-Default"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M9,16 L15,16 L15,10 L19,10 L12,3 L5,10 L9,10 L9,16 Z M5,18 L19,18 L19,20 L5,20 L5,18 Z"
                        id="Shape"
                        fill="currentColor"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

UploadIcon.propTypes = {
  className: PropTypes.string,
};

export default UploadIcon;
